function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function getPopoverStyles(_ref) {
  var arrowX = _ref.arrowX,
      arrowY = _ref.arrowY,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'top' : _ref$placement,
      _ref$strategy = _ref.strategy,
      strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy,
      x = _ref.x,
      y = _ref.y;
  var side = placement.split('-')[0];
  var oppositeSide = {
    top: 'bottom',
    right: 'left',
    bottom: 'top',
    left: 'right'
  }[side];
  return {
    arrow: _defineProperty({
      top: arrowY !== null && arrowY !== void 0 ? arrowY : '',
      left: arrowX !== null && arrowX !== void 0 ? arrowX : '',
      right: '',
      bottom: ''
    }, oppositeSide, '3px'),
    popover: {
      position: strategy,
      top: y !== null && y !== void 0 ? y : 0,
      left: x !== null && x !== void 0 ? x : 0
    }
  };
}

export default getPopoverStyles;